import { getConsentSnapshot } from "~/features/app/scripts/iubenda/controller";
import { hasKnownRegion, isUS } from "~/features/app/scripts/iubenda/model";

export const UTM_STORAGE_KEY = "ouster_utm_params";
export const UTM_PARAMETERS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function shouldClearStoredAttribution(snapshot: ReturnType<typeof getConsentSnapshot>) {
  return (
    snapshot.preferences.isReady &&
    !snapshot.preferences.marketing &&
    !snapshot.preferencesPending &&
    hasKnownRegion(snapshot.countryCode) &&
    (!isUS(snapshot.countryCode) || snapshot.usAcknowledged)
  );
}

export function getStoredUTMParams(): Record<string, string> {
  if (typeof window === "undefined") return {};

  const snapshot = getConsentSnapshot();
  const { marketing } = snapshot.preferences;
  if (!marketing) {
    if (shouldClearStoredAttribution(snapshot)) {
      try {
        window.localStorage.removeItem(UTM_STORAGE_KEY);
      } catch {
        // Attribution storage can be disabled independently of cookie preferences.
      }
    }
    return {};
  }

  try {
    const stored = window.localStorage.getItem(UTM_STORAGE_KEY);
    const parsed: unknown = stored ? JSON.parse(stored) : null;
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};

    return Object.fromEntries(
      Object.entries(parsed).filter(([key, value]) => UTM_PARAMETERS.includes(key) && typeof value === "string")
    );
  } catch {
    return {};
  }
}
